<template>
  <div class="mcontainer">
    <div class="breadcrumb-area py-0">
      <div class="breadcrumb">
        <ul class="m-0">
          <li><router-link to="/app/admin/jobs">Job Admin</router-link></li>
          <li class="active"><a href="#">Edit Job</a></li>
        </ul>
      </div>
    </div>
    <div class="max-w-5xl m-auto shadow-md rounded-md bg-white mt-5" v-if="!loadingDetail">
      <form @submit.prevent="actionSubmit()">
        <div class="text-center border-b py-4">
          <h3 class="font-bold text-lg">Edit Job Opportunity</h3>
        </div>
        <div class="p-7 space-y-5">
          <div>
            <label class="font-semibold">Judul Pekerjaan *</label><br>
            <input class="form-control" v-model="form.title" type="text" required placeholder="Contoh: Software Engineer">
          </div>
          <div>
            <label class="font-semibold">Deskripsi *</label><br>
            <Editor v-model="form.description" />
          </div>
          <div>
            <label class="font-semibold">Ringkasan (Excerpt)</label><br>
            <textarea class="form-control" v-model="form.excerpt" rows="2" placeholder="Ringkasan singkat job"></textarea>
          </div>
          <div>
            <label class="font-semibold">Tags (pisahkan dengan koma)</label><br>
            <input class="form-control" v-model="form.tags" type="text" placeholder="Contoh: PHP,Vue.js,Laravel">
          </div>
          <div>
            <label class="font-semibold">URL Form Lamaran</label><br>
            <input class="form-control" v-model="form.form_url" type="url" placeholder="https://forms.google.com/... atau link form lamaran lainnya">
            <p class="text-sm text-gray-500 mt-1">Jika diisi, tombol Apply Now akan muncul di halaman detail job</p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label class="font-semibold">Gaji Minimum (Rp) *</label><br>
              <input class="form-control" v-model.number="form.min_salary" type="number" min="0" required>
            </div>
            <div>
              <label class="font-semibold">Gaji Maksimum (Rp) *</label><br>
              <input class="form-control" v-model.number="form.max_salary" type="number" min="0" required>
            </div>
          </div>
          <div>
            <label class="font-semibold">Tipe Pekerjaan *</label><br>
            <select class="form-control" v-model="form.job_type" required>
              <option value="Full Time">Full Time</option>
              <option value="Part Time">Part Time</option>
              <option value="Contract">Contract</option>
              <option value="Internship">Internship</option>
              <option value="Freelance">Freelance</option>
            </select>
          </div>
          <div>
            <label class="font-semibold">Kategori</label><br>
            <select class="form-control" v-model="form.category_id">
              <option value="">Pilih kategori</option>
              <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.title }}</option>
              <option value="__other__">Other / Lainnya</option>
            </select>
            <input
              v-if="form.category_id === '__other__'"
              class="form-control mt-2"
              v-model="form.category_other"
              type="text"
              placeholder="Masukkan nama kategori lainnya"
            >
          </div>
          <div>
            <label class="font-semibold">Gambar Logo Perusahaan</label><br>
            <div class="image-uploader">
              <input type="file" ref="imagesInput" @change="onImagesSelected" accept="image/*">
              <span @click="$refs.imagesInput.click()"><Icon icon="bi:cloud-upload" /> Ganti gambar</span>
              <img v-if="previewImages || form.images_url" :src="previewImages || form.images_url" alt="Preview" class="w-32 h-32 object-cover rounded border">
              <div v-else class="w-32 h-32 rounded border border-dashed bg-gray-100 flex items-center justify-center text-gray-400">No image</div>
            </div>
          </div>
          <div>
            <label class="font-semibold">Gambar Banner</label><br>
            <div class="image-uploader">
              <input type="file" ref="bannerInput" @change="onBannerSelected" accept="image/*">
              <span @click="$refs.bannerInput.click()"><Icon icon="bi:cloud-upload" /> Ganti banner</span>
              <img v-if="previewBanner || form.banner_url" :src="previewBanner || form.banner_url" alt="Preview" class="w-full max-h-48 object-cover rounded border">
              <div v-else class="w-full h-32 rounded border border-dashed bg-gray-100 flex items-center justify-center text-gray-400">No banner</div>
            </div>
          </div>
        </div>
        <div class="border-t flex justify-center gap-3 border-gray-100 p-6">
          <router-link to="/app/admin/jobs" class="btn btn-secondary">Batal</router-link>
          <button type="submit" class="btn btn-primary" :disabled="submitting">
            <span v-if="!submitting">Update Job</span>
            <b-spinner v-if="submitting" small />
          </button>
        </div>
      </form>
    </div>
    <div v-else class="p-8 text-center"><b-spinner /> Loading...</div>
  </div>
</template>

<script>
import axios from 'axios'
import { Icon } from '@iconify/vue2'
import Editor from '@/components/Editor'

export default {
  name: 'JobAdminEdit',
  components: { Icon, Editor },
  data () {
    return {
      categories: [],
      form: {
        id: null,
        title: '',
        description: '',
        excerpt: '',
        tags: '',
        form_url: '',
        min_salary: '',
        max_salary: '',
        job_type: '',
        category_id: '',
        category_other: '',
        images_url: '',
        banner_url: '',
        images: null,
        banner: null
      },
      previewImages: '',
      previewBanner: '',
      submitting: false,
      loadingDetail: true
    }
  },
  created () {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail () {
      this.loadingDetail = true
      try {
        const [detailRes, catRes] = await Promise.all([
          axios.get(`/admin/jobs/${this.$route.params.id}`),
          axios.get('category?type=job')
        ])
        const data = detailRes.data
        this.categories = catRes.data.result || []
        this.form = {
          id: data.id,
          title: data.title,
          description: data.description || '',
          excerpt: data.excerpt || '',
          tags: data.tags || '',
          form_url: data.form_url || '',
          min_salary: data.min_salary,
          max_salary: data.max_salary,
          job_type: data.job_type,
          category_id: data.category_id || (data.category_other ? '__other__' : ''),
          category_other: data.category_other || '',
          images_url: data.images_url,
          banner_url: data.banner_url,
          images: null,
          banner: null
        }
      } catch (e) {
        this.$swal({ icon: 'error', title: 'Error', text: 'Gagal memuat data' }).then(() => {
          this.$router.push({ name: 'JobAdmin' })
        })
      } finally {
        this.loadingDetail = false
      }
    },
    onImagesSelected (e) {
      const file = e.target.files[0]
      if (file) {
        this.form.images = file
        this.previewImages = URL.createObjectURL(file)
      }
    },
    onBannerSelected (e) {
      const file = e.target.files[0]
      if (file) {
        this.form.banner = file
        this.previewBanner = URL.createObjectURL(file)
      }
    },
    async actionSubmit () {
      if (this.form.max_salary < this.form.min_salary) {
        this.$swal({ icon: 'error', title: 'Error', text: 'Gaji maksimum harus lebih besar dari gaji minimum' })
        return
      }
      if (this.form.category_id === '__other__' && !this.form.category_other.trim()) {
        this.$swal({ icon: 'error', title: 'Error', text: 'Harap isi nama kategori lainnya' })
        return
      }
      this.submitting = true
      try {
        const formData = new FormData()
        formData.append('title', this.form.title)
        formData.append('description', this.form.description)
        formData.append('excerpt', this.form.excerpt)
        formData.append('tags', this.form.tags)
        formData.append('form_url', this.form.form_url || '')
        if (this.form.category_id === '__other__') {
          formData.append('category_id', '')
          formData.append('category_other', this.form.category_other.trim())
        } else {
          formData.append('category_id', this.form.category_id || '')
        }
        formData.append('min_salary', this.form.min_salary)
        formData.append('max_salary', this.form.max_salary)
        formData.append('job_type', this.form.job_type)
        if (this.form.images && this.form.images instanceof File) {
          formData.append('images', this.form.images)
        }
        if (this.form.banner && this.form.banner instanceof File) {
          formData.append('banner', this.form.banner)
        }

        await axios.post(`/admin/jobs/${this.form.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })

        this.$swal({
          icon: 'success',
          title: 'Berhasil',
          text: 'Job berhasil diupdate'
        }).then(() => {
          this.$router.push({ name: 'JobAdmin' })
        })
      } catch (e) {
        const msg = e.response?.data?.message || e.response?.data?.error || 'Gagal update job'
        this.$swal({ icon: 'error', title: 'Error', text: msg })
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.form-control { width: 100%; padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 8px; }
.image-uploader { display: flex; flex-direction: column; gap: 8px; }
.image-uploader span { cursor: pointer; color: #0ea5e9; }
.btn { padding: 8px 16px; border-radius: 8px; text-decoration: none; display: inline-flex; align-items: center; gap: 6px; }
.btn-primary { background: #0ea5e9; color: #fff; border: none; cursor: pointer; }
.btn-secondary { background: #e5e7eb; color: #374151; }
</style>
